import React from 'react';
import { getIdentifiers } from './identifiers';
import { Script as Facebook } from './Facebook';
import { Script as Twitter } from './Twitter';
import { Context } from '../LocaleWrapper';

const scriptFunctions: { [key: string]: (locale: string) => string } = {
  facebook: Facebook,
  twitter: Twitter,
};

export function Scripts(): React.ReactElement | null {
  const { channel, i18n } = React.useContext(Context);
  const { locale } = channel;
  const identifiers = getIdentifiers(i18n);

  if (!identifiers) {
    return null;
  }

  const scripts = identifiers.map((identifier: string) =>
    scriptFunctions[identifier](locale)
  );

  return <div dangerouslySetInnerHTML={{ __html: scripts.join('\n\n') }} />;
}
